// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"72":"c879d28f0b123339","117":"f2ef12043979525f","292":"27c1c00158f95f93","382":"0236e3e9f9e3e62f","708":"bd6d2034f753d88c","822":"fa18cbbdf01d94fc"}[chunkId] + ".js";
};